import { render, staticRenderFns } from "./HandlerBenefits.vue?vue&type=template&id=499528fe&scoped=true&"
import script from "./HandlerBenefits.vue?vue&type=script&lang=js&"
export * from "./HandlerBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499528fe",
  null
  
)

export default component.exports